<template>
  <b-container fluid class="w-100 h-100 m-0 p-0">
    <div class="video-container align-items-center d-flex">
      <b-container>
        <b-row align-v="center" class="mt-2">
          <PlayerItem :item="display_object" :debug="false" :replay="false" style="margin: auto;" ref="video" @ended="on_end()" @play="play" @canplay="timeupdate" @playing="update_paused" @pause="update_paused" @timeupdate="timeupdate" />
        </b-row>
        <b-row class='mt-4 cta-cards' v-if="project && project.cards">
          <b-col class='d-flex align-items-stretch' v-for="(card, index) in project.cards" v-bind:key="index">
            <b-card :title='card.title' class='px-3 py-1 cta-card'>
              <b-card-text>{{card.text}}</b-card-text>
              <b-card-text><b-link class='text-primary cursor-pointer' href='#' @click="go_to_cta(card.link_url)">{{card.link_text}}</b-link></b-card-text>
            </b-card>
          </b-col>
        </b-row>
      </b-container>
    </div>


  </b-container>
</template>

<script>

import {db, analytics} from '@/main.js'
import Tracking from '@/mixins/Tracking.js'
import PlayerItem from '@/components/PlayerItem.vue'

export default {
  name: 'VideoPlayer',
  mixins: [Tracking],
  components: {PlayerItem},
  data() {
    return {
      endcard: false,
      project: undefined,
      item: undefined,
      playing: false,
      start: true,
      watch_seconds: 0,
      watch_percentage: 0,
      duration: null,
      display_object: undefined
    }
  },
  methods: {
    update_paused(event) {
      this.paused = this.$refs.video.paused
      this.playing = true
    },
    timeupdate(event) {
      let seconds = Math.floor(this.$refs.video.currentTime)
      if (seconds > this.watch_seconds) {
        this.watch_seconds = seconds
        this.watch_percentage =  Math.floor(seconds /  Math.floor(this.$refs.video.duration) * 100)
      }

      if (this.duration === null) {
        this.duration = this.$refs.video.duration
      }
    },
    on_end() {
      this.add_event('finished')
      this.playing = false
      // if (this.project.cta_text && this.project.cta_url) {
      this.endcard = true
      this.$bvModal.show('endcard')
      // }
    },
    // replay() {
    //   this.add_event('replayed')
    //   this.endcard = false
    //   this.$bvModal.hide('endcard')
    //   this.$refs.video.play()
    //   this.playing = true
    // },
    play() {
      this.set_email_if_first_visit()
      this.add_event('played')
      // this.$refs.video.play()
      // this.playing = true
      // this.start = false
    },
    async go_to_cta(url) {
      await this.add_event('clicked', {url: url})
      window.parent.parent.window.location = url
    },
    async add_event(type, data) {
      let visitor = null
      try {
        visitor = await this.tracking_data()
      } catch(err) {
        console.warn(err)
        // pass
      }

      data = data ? data : null

      // console.log('visitor', visitor)

      let proms = []
      if (this.$route.query.item) {
        proms.push(db.collection('project').doc(this.$route.query.project).collection('item').doc(this.$route.query.item).collection('event').add({created: new Date(), type: type, action: type, data: data, visitor: visitor}))
      }
      if (this.$route.query.sequence && this.$route.query.recipient && this.$route.query.step) {
        let track = {created: new Date(), action: type, visitor: visitor}
        proms.push(db.collection('sequence').doc(this.$route.query.sequence).collection('recipient').doc(this.$route.query.recipient).collection('step').doc(this.$route.query.step).collection('event').add(track))
      }

      return Promise.all(proms)
    },
    async set_email_if_first_visit() {
      // console.log('set_email_if_first_visit')

      // If this is the first time the video is watched the track the email address of the recipient
      if (this.$route.query.sequence && this.$route.query.recipient) {
        let recipient_doc = await db.collection('sequence').doc(this.$route.query.sequence).collection('recipient').doc(this.$route.query.recipient).get()
        let recipient = recipient_doc.data()

        if (!recipient.tracked) {
          let latest_recording
          try {
            // eslint-disable-next-line
            latest_recording = FS.getCurrentSessionURL()
          } catch(err) {
            // pass
          }

          let visitor = null
          try {
            visitor = await this.tracking_data(true)
          } catch(err) {
            console.warn(err)
            // pass
          }

          // console.log(recipient.email, visitor)

          analytics.identify(recipient.email, {email: recipient.email, latest_recording: latest_recording, extensions: visitor.extensions, utc_offset: visitor.utc_offset, ip_country: visitor.country})

          await recipient_doc.ref.update({updated: new Date(), tracked: true})
        }
      }
    },
    beforeunload(event) {
      this.add_event('watch_time', {watch_seconds: this.watch_seconds, watch_percentage: this.watch_percentage})
    }
  },
  mounted() {
    window['_fs_is_outer_script'] = true // https://help.fullstory.com/hc/en-us/articles/360020622514-Can-FullStory-capture-content-that-is-presented-in-iframes-

    this.add_event('visited')
    document.addEventListener('contextmenu', event => event.preventDefault())
    window.addEventListener("beforeunload", this.beforeunload)

    if (this.$route.query.project && this.$route.query.item) {
      this.$bind('project', db.collection('project').doc(this.$route.query.project))
      this.$bind('item', db.collection('project').doc(this.$route.query.project).collection('item').doc(this.$route.query.item))
    } else if (this.$route.query.project) {
      this.$bind('project', db.collection('project').doc(this.$route.query.project))
      this.item = null
    } else {
      alert('invalid url')
    }
  },
  watch: {
    'item': {
      deep: true,
      handler: function() {
        if (this.item === null) {
          this.display_object = this.project
          return
        }

        if (this.item.status !== 'complete' && this.project) {
          if (this.project.fallback_video_url) {
            this.display_object = this.project
          } else {
            this.display_object = this.item
          }
        }

        if (this.item.status === 'complete' && ['bin', 'fail'].indexOf(this.item.quality_control_status == -1)) {
          this.display_object = this.item
        }

        if (this.item.status === 'deleted' || (this.project && this.project.status === 'deleted')) {
          this.display_object = null
        }
      }
    },
    'project': {
      deep: true,
      handler: function() {
        if (this.project === null) {
          this.display_object = null
          this.$unbind('project', false)
          return
        }

        if (this.$route.query.project && !this.$route.query.item) {
          this.display_object = this.project
        }

        if (this.item && (this.item.status !== 'complete' || ['bin', 'fail'].indexOf(this.item.quality_control_status > -1))) {
          if (this.project && this.project.fallback_video_url) {
            this.display_object = this.project
          } else {
            this.display_object = this.item
          }
        }

        if (this.project.status === 'deleted' || (this.item && this.item.status === 'deleted')) {
          this.display_object = null
        }

        if (this.project) {
          this.$unbind('project', false)
        }
      }
    },
  }
}
</script>

<style scoped>

.video-container {
  /* background: #000 !important; */
  width: 100%;
  min-height: 100vh;
  position:relative;
}

.cta-cards {
  max-width: 900px;
  margin: auto;
}

.cta-card {
  margin: auto;
  max-width: 480px;
  width: 100%;
  min-width: 14em;
  margin-bottom: 1em;
}

.cta-card .card-title {
  font-size: 18px;
  font-weight: 600;
}

.cta-card .card-text {
  font-size: 14px;
}

</style>
